export enum EOrderType {
    PRODUCTION = 'production',
    DRAFT = 'draft',
    FINISHED = 'finished'
}

export enum EOrderStatus {
    DRAFT = 0,
    NEW = 1,
    APPROVAL = 2,
    PENDING = 3,
    PRODUCTION = 4,
    PROOF = 5,
    DELAYED = 6,
    FINISHED = 7,
    DELIVERED = 8,
    CANCELLED = 9,
    SUSPENDED = 10
}

export enum EOrderRemakeType {
    REMAKE = 1,
    ADJUSTMENT = 2
}

export enum EOrderRemakeResponsibility {
    CUSTOMER = 'customer',
    LAB = 'lab'
}

export enum EOrderLinkType {
    REMAKE = 1,
    ADJUSTMENT = 2,
    SEQUENCE = 3
}

export enum EOrderDateType {
    EXPECTED = 0,
    PRODUCTION = 1,
    LABORATORY = 2,
    START = 3,
    FINISHED = 4
}

export enum EOrderMediaType {
    PUBLIC = 'public',
    PRIVATE = 'private'
}

export enum EOrderReasonType {
    REMAKE = 1,
    SUSPENDED = 2,
    CANCELLED = 3
}

export enum EOrderDelayStatusType {
    EXPECTED_DATE = 1,
    LABORATORY_DATE = 2
}
